export function oxfordComma(items: string[]): string {
  if (items.length === 1) return items[0]
  const itemsClone = [...items]
  const lastItem = itemsClone.pop()
  return itemsClone.join(', ') + `, and ${lastItem}`
}
